module.exports = __webpack_public_path__ + "img/tr_ic_arrow-left.e20763ea.svg";